import { Card, Divider, Drawer, Input, Modal, Select, Tag } from "antd";
import TextArea from "antd/es/input/TextArea";
import { CardHeader } from "Components/Atoms/CardHeader";
import Editor from "Components/Editor";
import formatter from 'html-formatter';
import React from "react";
import AceEditor from 'react-ace';
import { AiFillCloseCircle, AiFillEye } from "react-icons/ai";
import { BiCodeAlt } from "react-icons/bi";
import { MdPublish } from "react-icons/md";
import { toast } from "react-toastify";
import AdminServicesPYV2 from "services/api/AdminServicesPYV2";

export default function CreateKBArticle() {

    const allAuthors = [
        { value: "Shubham Satyarth", label: "Shubham Satyarth" },
        { value: "Avinash Bhatt", label: "Avinash Bhatt" },
        { value: "Pranav Nanekar", label: "Pranav Nanekar" },
    ]
    const [title, setTitle] = React.useState('');
    const [author, setAuthor] = React.useState();
    const [keywords, setKeywords] = React.useState([]);
    const [content, setContent] = React.useState('');
    const [tag, setTag] = React.useState('');
    const [tree, setTree] = React.useState([]);
    const [sectionName, setSectionName] = React.useState('');
    const [allArticles, setAllArticles] = React.useState([])
    const [description, setDescription] = React.useState('');
    const [previewHTML, setPreviewHTML] = React.useState(false);
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const onChangeTitle = (e) => {
        setTitle(e.target.value);
    };

    const onChangeAuthor = (value) => setAuthor(value);

    const onChangeContent = (value) => {
        setContent(value);
    };

    const onChangeDescription = (value) => {
        setDescription(value);
    }

    const handleAddTag = (e) => {
        if (e.key === 'Enter' && (String(e.target.value).trim())) {
            setKeywords([...keywords, String(e.target.value).trim()])
            setTag("");
        }
    }

    const handleTagRemove = (e, i) => {
        let temp = [...keywords];
        temp.splice(i, 1);
        setKeywords(temp)
    }

    const handleValidations = () => {
        let fileName = String(title).toLowerCase().replaceAll(' ', '-');
        let tree2 = tree?.join('|');
        let url = `knowledge-base/${String(tree2).toLowerCase()?.replaceAll(' ', '-')?.replaceAll('|', '/')}`;
        let temp = allArticles?.filter((item) => {
            return item?.URL === url && (String(item?.Title).toLowerCase().replaceAll(' ', '-') === fileName)
        });
        if (!title.trim()) {
            toast.warn("Enter valid title");
            return false;
        }
        else if (!author) {
            toast.warn("Choose a valid author!");
            return false;
        }
        else if (!(String(description).trim())) {
            toast.warn("Enter valid description!");
            return false;
        }
        else if (!(keywords?.length)) {
            toast.warn("Enter valid keywords");
            return false;
        }
        else if (!content) {
            toast.warn("Content is empty!");
            return false
        }
        else if (temp.length) {
            toast.error("Resource with same title already exists!");
            return false;
        }
        else {
            return true;
        }
    }

    const handlePublish = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (handleValidations()) {
            let fileName = String(title).toLowerCase().replaceAll(' ', '-');
            let tree2 = tree?.join('|');
            let url = String(tree2).toLowerCase()?.replaceAll(' ', '-')?.replaceAll('|', '/');
            let data = {
                "UID": 0,
                "Title": String(title).trim(),
                "Description": String(description).trim(),
                "Keywords": keywords.join(',') || "",
                "Author": String(author),
                "Content": content,
                "FileName": `${fileName}.html`,
                "Tree": tree2,
                "URL": `knowledge-base/${url}`
            }
            let res = await AdminServicesPYV2.addKnowledgeBaseArticle(data);
            if (res.type) {
                toast.success("Article published.");
            }
            let res2 = await AdminServicesPYV2.getAllKnowledgeBaseArticles();
            if (res2?.type) {
                if (res2?.data?.length > 0) {
                    setAllArticles(JSON.parse(res2?.data));
                }
            }
        }
        setLoading(false);
    }

    const loadData = async () => {
        let res = await AdminServicesPYV2.getAllKnowledgeBaseArticles();
        if (res?.type) {
            if (res?.data?.length > 0) {
                setAllArticles(JSON.parse(res?.data));
            }
        }
    }

    React.useEffect(() => {
        loadData();
    }, []);

    React.useEffect(() => {
        if (openDrawer) {
            document.getElementById('blog-preview-drawer').innerHTML = content;
        }
    }, [openDrawer])

    return (
        <React.Fragment>
            <Card style={{ padding: 0 }} bodyStyle={{ padding: "1rem" }}>
                <div className='d-flex justify-content-between flex-column flex-md-row ' style={{ gap: "10px" }}>
                    <CardHeader heading={'Create article'} />
                    <div style={{ display: "flex", gap: "20px" }}>
                        <button className='btnPrimary' onClick={() => {
                            setOpenDrawer(true)
                        }}>
                            <AiFillEye className='mr-2' /> Preview
                        </button>
                        <button className='btnBlack' onClick={() => setPreviewHTML(true)}>
                            <BiCodeAlt className='mr-2' />See HTML
                        </button>
                    </div>
                </div>
                <Divider style={{ margin: "1rem 0" }} />
                <div className='mt-3'>
                    <label>Title:</label>
                    <br />
                    <Input placeholder='Title' value={title} name='title' onChange={onChangeTitle} style={{ padding: "5px 10px" }} className='textMD' />
                    <div className="textSM mt-1">Note: Don't use special symbols like <b>&</b>,<b>?</b>,<b>/</b>,<b>'</b> in title and Sections.</div>
                </div>
                <div className="grid-container" style={{ '--itemMinWidth': "280px", marginTop: "10px" }}>
                    <div className='mt-2'>
                        <label>
                            Author:
                        </label>
                        <br />
                        <Select placeholder='Select a author' showSearch onChange={onChangeAuthor}
                            style={{ width: "280px" }} optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                            } value={author} >
                            {allAuthors.map((item) => (
                                <Select.Option key={item.value} value={item.value}>
                                    {item.value}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className='mt-2'>
                        <label>
                            Keywords:
                        </label>
                        <br />
                        <div className="d-flex align-items-center flex-wrap rounded" style={{ width: "280px", gap: "5px" }}>
                            {keywords.length ? <div className="d-flex flex-wrap rounded" style={{ gap: "3px" }}>
                                {keywords.map((item, i) => (
                                    <span key={item + i} style={{ display: 'inline-block' }}>
                                        <Tag closable={true} onClose={(e) => handleTagRemove(e, i)} closeIcon={<AiFillCloseCircle color='var(--black)' />}>
                                            {item}
                                        </Tag>
                                    </span>
                                ))}
                            </div> : null}
                            <Input className='flex-grow-1 ' placeholder='Add keywords (Press Enter to add)'
                                onChange={(e) => setTag(e.target.value)} onKeyDown={handleAddTag} value={tag} />
                        </div>
                    </div>
                </div>
                <div className='mt-3'>
                    <label>
                        Sections:
                    </label>
                    <br />
                    <div className="d-flex align-items-center flex-wrap rounded" style={{ gap: "5px" }}>
                        {tree.length ? <div className="d-flex flex-wrap rounded" style={{ gap: "3px" }}>
                            {tree.map((item, i) => (
                                <span key={item + i} style={{ display: 'inline-block' }}>
                                    <Tag closable={true} onClose={(e) => {
                                        let temp = [...tree];
                                        temp.splice(i, 1);
                                        setTree(temp)
                                    }} closeIcon={<AiFillCloseCircle color='var(--black)' />}>
                                        {item}
                                    </Tag>
                                </span>
                            ))}
                        </div> : null}
                        <Input className='flex-grow-1 ' placeholder='Add sections (Press Enter to add)'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && (String(e.target.value).trim())) {
                                    setTree([...tree, String(e.target.value).trim()])
                                    setSectionName('');
                                }
                            }} value={sectionName} onChange={(e) => setSectionName(e.target.value)} />
                    </div>
                    <div className="textXS w-500 mt-1">Note: Theses sections are basically categories at decreasing heirchical levels inside which the article will be shown in knowledge base sidebar.
                        Please ensure proper spelling & letter casing while adding sections as it will be shown without any change in sidebar in knowledge base.</div>
                </div>
                <div className='mt-3'>
                    <label>Description:</label>
                    <br />
                    <TextArea className='' style={{ width: "100%", height: "100px", resize: "none", fontSize: "16px" }}
                        placeholder='Enter description' value={description} onChange={(e) => onChangeDescription(e.target.value)} />
                </div>
                <div className='mt-3'>
                    <label>Content:</label>
                    <Editor onChange={onChangeContent} />
                </div>
                <div className='mt-3'>
                    <button className='btnPrimary' onClick={handlePublish} disabled={loading}>
                        <MdPublish className='mr-2' /> Publish
                    </button>
                </div>
                <Modal onOk={() => setPreviewHTML(false)} open={previewHTML} title='HTML Content' onCancel={() => setPreviewHTML(false)}
                    zIndex={1021}>
                    <AceEditor
                        placeholder="Write something"
                        mode="html"
                        fontSize={14}
                        onLoad={(editor) => {
                            editor.setReadOnly(true)
                        }}
                        width='100%'
                        showPrintMargin={true}
                        showGutter={true}
                        highlightActiveLine={true}
                        value={formatter.render(content)}
                        setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            wrap: true,
                        }} />
                </Modal>
                <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)} placement='right' title='Preview Blog'
                    styles={{ body: { color: "black", margin: "0px", padding: "0px", background: "white" } }}
                    closable={true}
                    closeIcon={<AiFillCloseCircle size='24px' />} width='100%' zIndex={1021}
                >
                    <div className='ql-editor'>
                        <h2>
                            {title}
                        </h2>
                        <div id='blog-preview-drawer'>
                        </div>
                    </div>
                </Drawer>
            </Card>
        </React.Fragment>
    )
}